import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=6b98fc6e"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"
import style0 from "./Tasks.vue?vue&type=style&index=0&id=6b98fc6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports